import React, { useRef } from 'react';
import Styled from 'styled';
import range from 'lodash/range';
import { FormattedMessage } from 'react-intl';
import { FieldInputProps } from 'formik';

import Select from 'four-nets/ui-v2/form/select/select';
import defaultStyles from './date-select.scss';

const MONTHS_SLOVAK: { [id: number]: string } = {
    0: 'Január',
    1: 'Február',
    2: 'Marec',
    3: 'Apríl',
    4: 'Máj',
    5: 'Jún',
    6: 'Júl',
    7: 'August',
    8: 'September',
    9: 'Október',
    10: 'November',
    11: 'December',
};

const MONTHS_CZECH: { [id: number]: string } = {
    0: 'Leden',
    1: 'Únor',
    2: 'Březen',
    3: 'Duben',
    4: 'Květen',
    5: 'Červen',
    6: 'Červenec',
    7: 'August',
    8: 'September',
    9: 'Říjen',
    10: 'November',
    11: 'December',
};

export interface YearRange {
    min: number;
    max: number;
}

interface Props {
    dayField: FieldInputProps<any>;
    monthField: FieldInputProps<any>;
    yearField: FieldInputProps<any>;
    styles: typeof defaultStyles;
    yearRange?: YearRange;
    allowZero?: boolean;
}

const DateSelect: React.FC<Props> = (props, context) => {
    const { styles, dayField, monthField, yearField, allowZero, yearRange } = props;
    const maxYear = yearRange ? yearRange.max : new Date().getFullYear();
    const minYear = yearRange ? yearRange.min : 1900;

    return (
        <div className={styles.datePreciseWrapper}>
            <div className={styles.dateDayFieldWrapper}>
                <label className={styles.label} htmlFor='day'>
                    <FormattedMessage id='DAY' />
                </label>
                <Select {...(dayField as any)} multiple={false}>
                    <option disabled={!allowZero} value={-1}>
                        ---
                    </option>
                    {range(1, 32).map((index: number) => {
                        return (
                            <option key={index} value={index}>
                                {index}
                            </option>
                        );
                    })}
                </Select>
            </div>
            <div className={styles.dateMonthFieldWrapper}>
                <label className={styles.label} htmlFor='month'>
                    <FormattedMessage id='FORM_LABEL_MONTH' />
                </label>
                <Select {...(monthField as any)} multiple={false}>
                    <option disabled={!allowZero} value={-1}>
                        ---
                    </option>
                    {range(12).map((index: number) => {
                        return (
                            <option key={index} value={index}>
                                {context && context.site && context.site.isCzech
                                    ? MONTHS_CZECH[index]
                                    : MONTHS_SLOVAK[index]}
                            </option>
                        );
                    })}
                </Select>
            </div>
            <div className={styles.dateYearFieldWrapper}>
                <label className={styles.label} htmlFor='year'>
                    <FormattedMessage id='FORM_LABEL_YEAR' />
                </label>
                <Select {...(yearField as any)} multiple={false}>
                    <option disabled={!allowZero} value={-1}>
                        ---
                    </option>
                    {range(maxYear, minYear - 1).map(index => {
                        return (
                            <option key={index} value={index}>
                                {index}
                            </option>
                        );
                    })}
                </Select>
            </div>
        </div>
    );
};

export default Styled(defaultStyles)(DateSelect);
